import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLang } from "../context/LanguageContext";
import { EditorialHeading } from "./Reveal";

export const FAQ = () => {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <EditorialHeading kicker={t.faq.kicker} lines={t.faq.lines} size="text-4xl sm:text-5xl" />
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="space-y-3">
            {t.faq.items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-xl border border-[#e8e5e0] bg-white px-6 data-[state=open]:border-[#ff6b00]/50 shadow-sm"
              >
                <AccordionTrigger className="font-display text-base sm:text-lg text-left text-neutral-800 hover:no-underline hover:text-[#ff6b00] py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-neutral-500 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
